import { Checkbox, Dropdown, Flex, Heading } from "monday-ui-react-core";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";

import type { BoardDropdownOption } from "@/components/QuickSearch/components/BoardDropdown/models/boardDropdownOption";
import type { DropdownOption } from "@/components/QuickSearch/components/DropdownList/models/dropdownOptions";
import { formatToBoardDropdownOption } from "@/components/QuickSearch/components/DropdownList/utils/formatToDropdownOption";
import type { Board } from "@/types/common";
import { CheckOption } from "@/types/common";

interface BoardSelectionProps {
  boards: Board[];
  boardId: number;
  children?: React.ReactNode;
  allBoardItemsFlag: CheckOption;
  onAllBoardItemsFlagChange: () => unknown;
}

export function BoardSelection({ boards, boardId, onAllBoardItemsFlagChange, allBoardItemsFlag }: BoardSelectionProps) {
  const [selectedBoard, setSelectedBoard] = useState<DropdownOption>();
  const onMenuOpen = () => {};

  // TODO: JCPPMONDAY-118: Reload the selected board in Select Items to clone UI. fix me MNi
  const handleChange = () => {};

  const boardsToOptions = useMemo<BoardDropdownOption[]>(() => {
    return boards.map(formatToBoardDropdownOption);
  }, [boards]);

  useEffect(() => {
    const boardOption = boardsToOptions.find((option) => option.value === boardId);
    setSelectedBoard(boardOption);
  }, [boardsToOptions]);

  return (
    <BoardSelectionWrapper>
      <Heading type={Heading.types.h5} value="Select board" />
      <Flex direction={Flex.directions.ROW} align={Flex.align.STRETCH} gap={Flex.gaps.SMALL}>
        <DropdownWrapper>
          <Dropdown
            placeholder="Please select board"
            clearable={false}
            disabled={true}
            options={boardsToOptions}
            value={selectedBoard}
            insideOverflowContainer={true}
            menuPlacement={"auto"}
            onMenuOpen={onMenuOpen}
            onChange={handleChange}
          />
        </DropdownWrapper>
        <CheckboxWrapper>
          <Checkbox
            disabled={false}
            indeterminate={false}
            checked={allBoardItemsFlag === CheckOption.TRUE}
            onChange={onAllBoardItemsFlagChange}
            label="Clone everything from this board"
          />
        </CheckboxWrapper>
      </Flex>
    </BoardSelectionWrapper>
  );
}
const BoardSelectionWrapper = styled.div`
  font-family: var(--font-family);
  h5 {
    margin-bottom: 8px;
    padding-left: 0;
  }
`;

const DropdownWrapper = styled.div`
  flex-grow: 1;
  max-width: 300px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;
